import { createStyles } from '@mui/styles';
import { APTheme } from '../../../../core/TenantProvider/tenants';

import CommonStyles from './Common.style';

export default (theme: APTheme) => createStyles({
  ...CommonStyles(theme),
  panelContainer: {

  },
  formSectionContent: {
    padding: '0 20px 20px 20px',
    '@media(max-width: 768px)': {
      padding: '0 10px 10px 10px',
    },
  }
});
